var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "form",
      {
        attrs: { id: "items-services-form", "data-abide": "", novalidate: "" },
      },
      [
        _vm._l(_vm.itemServicesData, function (itemService, index) {
          return _c(
            "div",
            { key: itemService.id, staticClass: "card-section hover" },
            [
              _c(
                "div",
                {
                  staticClass: "title",
                  class:
                    _vm.highlightDeleteChange(itemService.addendumLabel) ||
                    _vm.highlightNonDeleteChange(itemService.addendumLabel),
                },
                [_vm._v("\n        " + _vm._s(itemService.title) + "\n      ")]
              ),
              _vm._v(" "),
              itemService.sectionDesc
                ? _c(
                    "div",
                    {
                      staticClass: "description",
                      class:
                        _vm.highlightDeleteChange(itemService.addendumLabel) ||
                        _vm.highlightNonDeleteChange(itemService.addendumLabel),
                    },
                    [
                      _c("pre", [
                        _c("p", [
                          _vm._v(_vm._s(itemService.sectionDesc || "")),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("table", [
                _c("thead", [
                  _c("th", { staticClass: "number" }, [
                    _vm._v("\n            #\n          "),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticStyle: { "padding-left": "0" } }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.descOfWork")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "qty-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.qty")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "unit-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.unit")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "rate-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.rate")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "unit-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.total")) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(itemService.lineItems, function (item) {
                      return [
                        _c(
                          "tr",
                          {
                            key: item.itemNo,
                            staticClass: "line-item-row",
                            class:
                              _vm.highlightDeleteChange(
                                itemService.addendumLabel,
                                item.addendumLabel
                              ) ||
                              _vm.highlightNonDeleteChange(item.addendumLabel),
                          },
                          [
                            _c("td", { staticClass: "number" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.itemNo) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "desc-of-work-text" }, [
                              _c("pre", { staticClass: "none-x-scroll" }, [
                                _c("p", { staticClass: "no-margin-bottom" }, [
                                  _vm._v(_vm._s(item.itemDesc)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm.editView
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: item.itemQty,
                                        expression: "item.itemQty",
                                      },
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                      {
                                        name: "fusioninputcheck",
                                        rawName: "v-fusioninputcheck",
                                        value: {
                                          type: "decimal",
                                          pattern: function (val) {
                                            return (Number(val) || 0) > 0
                                          },
                                          required:
                                            !_vm.disabledDeletedItem(
                                              itemService.addendumLabel,
                                              item.addendumLabel
                                            ) &&
                                            (!itemService.forReference ||
                                              item.itemQty),
                                        },
                                        expression:
                                          "{\n                    type: 'decimal',\n                    pattern: (val) => (Number(val) || 0) > 0,\n                    required: !disabledDeletedItem(itemService.addendumLabel, item.addendumLabel) && (!itemService.forReference || item.itemQty)\n                  }",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      autocomplete: "off",
                                      disabled: _vm.disabledDeletedItem(
                                        itemService.addendumLabel,
                                        item.addendumLabel
                                      ),
                                    },
                                    domProps: { value: item.itemQty },
                                    on: {
                                      change: function () {
                                        return _vm.updateRate(
                                          item,
                                          _vm.bidServiceData.bidItemRates[
                                            item.id
                                          ]
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          item,
                                          "itemQty",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _c("p", { staticClass: "plain view-field" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          new _vm.SafeNumber(
                                            item.itemQty
                                          ).toSafeString()
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "unit-text" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.itemUnit) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm.editView
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.bidServiceData.bidItemRates[
                                            item.id
                                          ],
                                        expression:
                                          "bidServiceData.bidItemRates[item.id]",
                                      },
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                      {
                                        name: "fusioninputcheck",
                                        rawName: "v-fusioninputcheck",
                                        value: {
                                          type: "decimal",
                                          required:
                                            !_vm.disabledDeletedItem(
                                              itemService.addendumLabel,
                                              item.addendumLabel
                                            ) &&
                                            (!itemService.forReference ||
                                              _vm.bidServiceData.bidItemRates[
                                                item.id
                                              ]),
                                        },
                                        expression:
                                          "{\n                    type: 'decimal',\n                    required: !disabledDeletedItem(itemService.addendumLabel, item.addendumLabel) && (!itemService.forReference || bidServiceData.bidItemRates[item.id])\n                  }",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      autocomplete: "off",
                                      required: !itemService.forReference,
                                      disabled: _vm.disabledDeletedItem(
                                        itemService.addendumLabel,
                                        item.addendumLabel
                                      ),
                                    },
                                    domProps: {
                                      value:
                                        _vm.bidServiceData.bidItemRates[
                                          item.id
                                        ],
                                    },
                                    on: {
                                      change: function () {
                                        return _vm.updateRate(
                                          item,
                                          _vm.bidServiceData.bidItemRates[
                                            item.id
                                          ]
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.bidServiceData.bidItemRates,
                                          item.id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _c("p", { staticClass: "plain view-field" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          !isNaN(
                                            _vm.bidServiceData.bidItemRates[
                                              item.id
                                            ]
                                          )
                                            ? _vm.formatAmount(
                                                new _vm.SafeNumber(
                                                  _vm.bidServiceData.bidItemRates[
                                                    item.id
                                                  ]
                                                ).toSafeString()
                                              )
                                            : 0
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "unit-text total_font" }, [
                              _c("div", { staticClass: "item_total_column" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      !isNaN(item.total)
                                        ? _vm.formatAmount(item.total)
                                        : item.total
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(item.options, function (option) {
                          return _c(
                            "tr",
                            {
                              key: option,
                              class:
                                _vm.highlightDeleteChange(
                                  itemService.addendumLabel,
                                  item.addendumLabel,
                                  option.addendumLabel
                                ) ||
                                _vm.highlightNonDeleteChange(
                                  option.addendumLabel
                                ),
                            },
                            [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", { staticClass: "option-desc" }, [
                                _c("pre", { staticClass: "none-x-scroll" }, [
                                  _c("p", [_vm._v(_vm._s(option.optionDesc))]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [
                                _vm.editView
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.bidServiceData.bidItemRates[
                                              option.id
                                            ],
                                          expression:
                                            "bidServiceData.bidItemRates[option.id]",
                                        },
                                        {
                                          name: "fusioninputcheck",
                                          rawName: "v-fusioninputcheck",
                                          value: {
                                            type: "decimal",
                                            nullable: true,
                                          },
                                          expression:
                                            "{type: 'decimal', nullable: true}",
                                        },
                                        {
                                          name: "hkldinput",
                                          rawName: "v-hkldinput",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                        autocomplete: "off",
                                        disabled: _vm.disabledDeletedItem(
                                          itemService.addendumLabel,
                                          item.addendumLabel,
                                          option.addendumLabel
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.bidServiceData.bidItemRates[
                                            option.id
                                          ],
                                      },
                                      on: {
                                        focusout: function ($event) {
                                          return _vm.updateRate(
                                            option,
                                            _vm.bidServiceData.bidItemRates[
                                              option.id
                                            ]
                                          )
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.bidServiceData.bidItemRates,
                                            option.id,
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c(
                                      "p",
                                      { staticClass: "plain view-field" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                new _vm.SafeNumber(
                                                  _vm.bidServiceData.bidItemRates[
                                                    option.id
                                                  ]
                                                ).toSafeString()
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                              ]),
                              _vm._v(" "),
                              _c("td"),
                            ]
                          )
                        }),
                      ]
                    }),
                    _vm._v(" "),
                    _c(
                      "tr",
                      {
                        staticStyle: { "text-align": "right", height: "85px" },
                      },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "total_panel total_font",
                            staticStyle: { "vertical-align": "middle" },
                            attrs: { colspan: "6" },
                          },
                          [
                            _c("div", { staticClass: "currency-summary" }, [
                              _c("div", { staticClass: "currency-label" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("tender.section.subtotal", [
                                        _vm.currencyCode,
                                      ])
                                    ) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "total_number" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      !isNaN(_vm.subTotals[index])
                                        ? _vm.formatAmount(_vm.subTotals[index])
                                        : _vm.subTotals[index]
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _vm.shouldShowOthersSection
          ? _c(
              "div",
              {
                staticClass: "item-services-add-others",
                class: { disabled: _vm.othersDisabled },
              },
              [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        class: _vm.highlightAllowServiceAddOthers,
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("tender.section.others")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.editView
                      ? _c(
                          "DottedDropdown",
                          {
                            attrs: { id: "item-services-add-others-dropdown" },
                          },
                          [
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: { disabled: _vm.othersDisabled },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addLine()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("action.addLine")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.otherItems.length
                  ? _c("table", [
                      _c("thead", [
                        _c("th", { staticClass: "number" }, [
                          _vm._v("\n            #\n          "),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticStyle: { "padding-left": "0" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("tender.section.descOfWork")) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "qty-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("tender.section.qty")) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "unit-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("tender.section.unit")) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "qty-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("tender.section.rate")) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "unit-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("tender.section.total")) +
                              "\n          "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.otherItems, function (line, lineIndex) {
                            return [
                              _c(
                                "tr",
                                {
                                  key: lineIndex,
                                  staticClass: "line-item-row",
                                },
                                [
                                  _c("td", { staticClass: "number" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(lineIndex + 1) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm.editView
                                      ? _c("textarea", {
                                          directives: [
                                            {
                                              name: "autosize",
                                              rawName: "v-autosize",
                                            },
                                          ],
                                          staticClass: "autosize desc-work",
                                          attrs: {
                                            id: _vm.addId(
                                              "line.desc",
                                              lineIndex
                                            ),
                                            type: "text",
                                            disabled: _vm.othersDisabled,
                                            placeholder: _vm.$t(
                                              "tender.section.description"
                                            ),
                                            required: true,
                                          },
                                          domProps: { value: line.itemDesc },
                                          on: {
                                            change: function (event) {
                                              return _vm.onLineChange(
                                                lineIndex,
                                                "itemDesc",
                                                event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _c(
                                          "pre",
                                          { staticClass: "none-x-scroll" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "no-margin-bottom",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(line.itemDesc) + " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticStyle: { width: "10%" } }, [
                                    _vm.editView
                                      ? _c("input", {
                                          staticClass: "qty-input",
                                          attrs: {
                                            id: _vm.addId(
                                              "line.qty",
                                              lineIndex
                                            ),
                                            type: "text",
                                            disabled: _vm.othersDisabled,
                                            required: true,
                                          },
                                          domProps: { value: line.itemQty },
                                          on: {
                                            change: function (event) {
                                              return _vm.onLineChange(
                                                lineIndex,
                                                "itemQty",
                                                event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _c(
                                          "p",
                                          { staticClass: "plain view-field" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  new _vm.SafeNumber(
                                                    line.itemQty
                                                  ).toSafeString()
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "unit-text",
                                      attrs: {
                                        id: _vm.addId("line.unit", lineIndex),
                                      },
                                    },
                                    [
                                      _vm.editView
                                        ? _c("HKLSelect", {
                                            attrs: {
                                              value: line.itemUnit || undefined,
                                              options: _vm.unitHklOptions,
                                              disabled: _vm.othersDisabled,
                                              showSearch: true,
                                              placeholder: "",
                                            },
                                            on: {
                                              change: function (value) {
                                                return _vm.onLineChange(
                                                  lineIndex,
                                                  "itemUnit",
                                                  value || ""
                                                )
                                              },
                                            },
                                          })
                                        : _c("span", [
                                            _vm._v(_vm._s(line.itemUnit)),
                                          ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm.editView
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: line.rate,
                                              expression: "line.rate",
                                            },
                                            {
                                              name: "fusioninputcheck",
                                              rawName: "v-fusioninputcheck",
                                              value: {
                                                type: "decimal",
                                                nullable: true,
                                              },
                                              expression:
                                                "{type: 'decimal', nullable: true}",
                                            },
                                            {
                                              name: "hkldinput",
                                              rawName: "v-hkldinput",
                                            },
                                          ],
                                          attrs: {
                                            id: _vm.addId(
                                              "line.rate",
                                              lineIndex
                                            ),
                                            type: "text",
                                            disabled: _vm.othersDisabled,
                                            required: true,
                                          },
                                          domProps: { value: line.rate },
                                          on: {
                                            change: function (event) {
                                              return _vm.onLineChange(
                                                lineIndex,
                                                "rate",
                                                event.target.value
                                              )
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                line,
                                                "rate",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _c(
                                          "p",
                                          { staticClass: "plain view-field" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  line.rate
                                                    ? _vm.formatAmount(
                                                        line.rate
                                                      )
                                                    : 0
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "unit-text total_font" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "total-dot-menu" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatAmount(line.total)
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm.editView
                                            ? _c(
                                                "DottedDropdown",
                                                {
                                                  attrs: {
                                                    id: _vm.addId(
                                                      "lineActions-dropdown",
                                                      lineIndex
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "li",
                                                    {
                                                      key: _vm.addId(
                                                        "lineDeleteLine",
                                                        lineIndex
                                                      ),
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            id: _vm.addId(
                                                              "lineDeleteLine",
                                                              lineIndex
                                                            ),
                                                            disabled:
                                                              _vm.othersDisabled,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteLine(
                                                                lineIndex
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "action.deleteLine"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            id: _vm.addId(
                                                              "lineAddLine",
                                                              lineIndex
                                                            ),
                                                            disabled:
                                                              _vm.othersDisabled,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.addLine(
                                                                lineIndex
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "action.addLine"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          }),
                          _vm._v(" "),
                          _c(
                            "tr",
                            {
                              staticClass: "item-services-add-others-subtotal",
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticClass: "total_panel total_font",
                                  staticStyle: { "vertical-align": "middle" },
                                  attrs: { colspan: "7" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "currency-summary" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "currency-label" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "tender.section.subtotal",
                                                  [_vm.currencyCode]
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "total_number" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.formatAmount(
                                                  _vm.bidServiceData
                                                    .totalOfOthers
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isEngineer && !_vm.isEmpty(_vm.bidServiceData.otherItem.rate)
          ? _c("div", [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tender.section.others")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("table", [
                _c("thead", [
                  _c("th", { staticClass: "number" }, [
                    _vm._v("\n            #\n          "),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticStyle: { "padding-left": "0" } }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.descOfWork")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "qty-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.qty")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "unit-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.unit")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "qty-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.rate")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "unit-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.section.total")) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", { staticClass: "line-item-row" }, [
                    _c("td", { staticClass: "number" }, [
                      _vm._v("\n              1\n            "),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.editView
                        ? _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.bidServiceData.otherItem.desc,
                                expression: "bidServiceData.otherItem.desc",
                              },
                              {
                                name: "fusioninputcheck",
                                rawName: "v-fusioninputcheck",
                                value: {
                                  type: "string",
                                  tip: _vm.$t("hint.inputTip.string"),
                                  pattern: function (val) {
                                    return (val || "").trim().length > 0
                                  },
                                  required: !!_vm.bidServiceData.otherItem.rate,
                                },
                                expression:
                                  "{\n                  type: 'string', tip: $t('hint.inputTip.string'),\n                  pattern: (val) => (val || '').trim().length > 0,\n                  required: !!bidServiceData.otherItem.rate\n                }",
                              },
                              { name: "autosize", rawName: "v-autosize" },
                              { name: "hkldinput", rawName: "v-hkldinput" },
                              {
                                name: "checkVisibility",
                                rawName: "v-checkVisibility",
                              },
                            ],
                            staticClass: "autosize",
                            class: { "plain-text": !_vm.editView },
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.bidServiceData.otherItem.desc,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.bidServiceData.otherItem,
                                  "desc",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c("p", { staticClass: "no-margin-bottom" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.bidServiceData.otherItem.desc) +
                                "\n              "
                            ),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "unit-text" }, [
                      _vm._v("\n              1\n            "),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "unit-text" }, [
                      _vm._v("\n              Lot\n            "),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.editView
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.bidServiceData.otherItem.rate,
                                expression: "bidServiceData.otherItem.rate",
                              },
                              {
                                name: "fusioninputcheck",
                                rawName: "v-fusioninputcheck",
                                value: {
                                  type: "decimal",
                                  required:
                                    !!_vm.bidServiceData.otherItem.rate ||
                                    (
                                      _vm.bidServiceData.otherItem.desc || ""
                                    ).trim().length > 0,
                                },
                                expression:
                                  "{\n                  type: 'decimal',\n                  required: !!bidServiceData.otherItem.rate || (bidServiceData.otherItem.desc || '').trim().length > 0}",
                              },
                              { name: "hkldinput", rawName: "v-hkldinput" },
                            ],
                            attrs: { type: "text", autocomplete: "off" },
                            domProps: {
                              value: _vm.bidServiceData.otherItem.rate,
                            },
                            on: {
                              focusout: function ($event) {
                                return _vm.refreshBidServiceData()
                              },
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.bidServiceData.otherItem,
                                  "rate",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c("p", { staticClass: "plain view-field" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    new _vm.SafeNumber(
                                      _vm.bidServiceData.otherItem.rate
                                    ).toSafeString()
                                  )
                                ) +
                                "\n              "
                            ),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "unit-text total_font" }, [
                      _c("div", { staticClass: "item_total_column" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.formatAmount(
                                _vm.bidServiceData.otherItem.rate
                              )
                            ) +
                            "\n              "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.bidServiceData.discountValue > 0 && _vm.isEngineer
          ? [
              _c("hr", {
                staticStyle: {
                  "margin-top": "40px",
                  "margin-bottom": "0",
                  width: "100%",
                  "max-width": "100%",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "total_panel total_font total_panel_currency currency-summary",
                },
                [
                  _c("div", { staticClass: "currency-label" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("tender.section.totalBeforeDiscount")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "total_number" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatAmount(_vm.totalBeforeDiscount)) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "discount-panel total_panel total_panel_currency",
                  attrs: { id: "bid-discount-panel" },
                },
                [
                  _c("div", { staticClass: "total_font currency-label" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("tender.section.discount")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "qty-text" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.bidServiceData.discountValue,
                          expression: "bidServiceData.discountValue",
                        },
                        {
                          name: "fusioninputcheck",
                          rawName: "v-fusioninputcheck",
                          value: {
                            type: "decimal",
                            required: !!_vm.bidServiceData.discountValue,
                          },
                          expression:
                            "{type: 'decimal', required: !!bidServiceData.discountValue}",
                        },
                        { name: "hkldinput", rawName: "v-hkldinput" },
                      ],
                      staticClass: "align-select",
                      class: { "plain-box": !_vm.editView },
                      attrs: { type: "text", readonly: !_vm.editView },
                      domProps: { value: _vm.bidServiceData.discountValue },
                      on: {
                        focusout: function ($event) {
                          return _vm.refreshBidServiceData()
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.bidServiceData,
                            "discountValue",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("HKLSelect", {
                        staticStyle: {
                          "min-width": "150px",
                          width: "170px",
                          "max-width": "100%",
                        },
                        attrs: {
                          id: "discount_type_list",
                          value: _vm.bidServiceData.discountType || undefined,
                          options: _vm.discountTypeHklOptions,
                          showSearch: true,
                          placeholder: "",
                          disabled: !_vm.editView,
                        },
                        on: { change: _vm.onDiscountTypeChange },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("hr", {
          staticStyle: {
            "margin-top": "40px",
            "margin-bottom": "0",
            width: "100%",
            "max-width": "100%",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "total_panel row align-middle" }, [
          _c("div", { staticClass: "small-7 medium-7 large-7 column" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "small-5 medium-5 large-5 column total_panel_currency currency-summary",
              staticStyle: { "padding-right": "0" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "total_font currency-label",
                  staticStyle: { color: "#e69500" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("tender.section.totalAmount", [_vm.currencyCode])
                      ) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "total_number",
                  staticStyle: { color: "#e69500" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.formatAmount(_vm.totalFeeAfterDiscount)) +
                      "\n        "
                  ),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("tender.section.remark")) + ":\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm.editView
            ? _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.bidServiceData.remark,
                    expression: "bidServiceData.remark",
                  },
                  { name: "hkldinput", rawName: "v-hkldinput" },
                ],
                class: { "plain-box": !_vm.editView },
                attrs: { type: "text" },
                domProps: { value: _vm.bidServiceData.remark },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.bidServiceData, "remark", $event.target.value)
                  },
                },
              })
            : _c("pre", [
                _vm._v("        "),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm._f("isEmptyValue")(_vm.bidServiceData.remark))
                  ),
                ]),
                _vm._v("\n      "),
              ]),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }